Apt.fn.make('account-post', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;
		const id = $.context('id');

		LS.common.setBasic(true);

		priv.id = id;
		priv.fired = [];

		$.view.addHelper('utility', function(index, fallback) {
			index = this.data.category;

			return this.val[index] || fallback;
		});

		LS.util.load('edit');

		LS.analytics.record();

		if (id) {
			LS.api.get('me/listings/' + id, {
				auth: true,
				success: data => {
					priv.syndicated = data.source !== 'direct';

					priv.setup(data);
				}
			});

			return;
		}

		LS.api.get('me/listings/access', {
			auth: true,
			success: data => {
				priv.access = data;

				if (data.total) {
					priv.setup();

					return;
				}

				$$('post').html(
					$.view.get('account-post.credits')
				)
					.removeClass('g-loading');
			}
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		const priv = this.$private;

		priv.unprotect();

		LS.common.setBasic();

		LS.util.reset('post', priv, [
			'app',
			'edit'
		]);

		delete priv.access;
		delete priv.currentStep;
		delete priv.syndicated;
	}
}, {
	/**
	 * Initialize the application
	 *
	 * @param {Object} [data]
	 */
	setup(data) {
		const scope = this;
		const $post = $$('post');
		const model = scope.buildModel();

		let auction;

		model.original = $.copy(data);

		model.access = scope.access;

		model.data = data || {
			format: 'sale',
			fsbo: true,
			images: [],
			tags: [],
			types: []
		};

		model.data.owner_financing = model.data.tags.includes('owner-financing') || model.data.financing;
		model.data.financing = model.data.financing || {};

		auction = model.data.auction;

		if (auction) {
			if (auction.begins_at) {
				auction.begins_at_date = auction.begins_at.slice(0, 10);
				auction.begins_at_time = auction.begins_at.slice(11, 16);
			}

			if (auction.ends_at) {
				auction.ends_at_date = auction.ends_at.slice(0, 10);
				auction.ends_at_time = auction.ends_at.slice(11, 16);
			}
		}

		model.data.auction = auction || {};
		model.data.lease = model.data.lease || {};

		if (data) {
			model.id = data.id;

			model.approved = data.approved;

			if (! LS.user.get('admin')) {
				model.restricted = ! scope.syndicated && data.approved;
				model.syndicated = scope.syndicated;
				model.locked = model.restricted || model.syndicated;
			}

			model.description = LS.util.markdown(data.description);
		}

		$.events.on('.-is-disabled', 'click', (e, el) => {
			LS.util.warn(el.dataset.message || 'Value cannot be edited — contact support');
		}, {
			delegate: '$post',
			namespace: 'post'
		});

		scope.app = $.app.make('post', {
			view: 'account-post.form',
			target: $post,
			model: model,
			events: {
				init: () => {
					$post.removeClass('g-loading');
				}
			}
		});

		scope.$form = $$('postForm');

		scope.setStep(model.step);

		scope.initForm();
		scope.initProgress();
		scope.initNav();
		scope.initModals();
		scope.initInputs();

		scope.selectFormat();

		scope.populateFinancing();
		scope.populateCriteria();

		scope.initSubmit();

		scope.protect();
	},

	/**
	 * Build model
	 *
	 * @returns {Object}
	 */
	buildModel() {
		const scope = this;
		const steps = {
			basic: {
				label: 'Basics'
			},
			detail: {
				label: 'Details'
			},
			criteria: {
				label: 'Criteria'
			},
			feature: {
				label: 'Features'
			},
			media: {
				label: 'Media'
			},
			review: {
				label: 'Review'
			},
			done: {
				label: 'Done'
			}
		};
		const end = new Date().getFullYear() + 1;
		const start = end - 10;
		const years = [];
		const available = [];
		const step = 1;

		for (let year = end; year > start; year--) {
			years.push(year);
		}

		Object.keys(steps).forEach((key, index) => {
			if (key === 'done') {
				return;
			}

			steps[key].available = scope.id || index < step;
		});

		const statuses = scope.syndicated ?
			{
				'active': 'Active',
				'canceled': 'Canceled',
				'closed': 'Closed / Sold',
				'coming-soon': 'Coming Soon',
				'delete': 'Delete',
				'expired': 'Expired',
				'hold': 'Hold',
				'inactive': 'Inactive',
				'incomplete': 'Incomplete',
				'pending': 'Pending',
				'active-under-contract': 'Under Contract',
				'withdrawn': 'Withdrawn'
			} : {
				'active': 'Active',
				'closed': 'Closed / Sold',
				'inactive': 'Inactive',
				'pending': 'Pending'
			};

		return {
			step: step,
			available: available,
			steps: steps,
			billing: {
				plan: 'standard'
			},
			statuses: statuses,
			formats: {
				sale: {
					title: 'For sale',
					icon: 'sales'
				},
				lease: {
					title: 'Lease',
					icon: 'leases',
					types: {
						'': 'Select one',
						'agricultural': 'Agricultural',
						'commercial': 'Commercial',
						'hunting': 'Hunting',
						'recreational': 'Recreational',
						'residential': 'Residential',
						'other': 'Other'
					},
					periods: {
						'': 'Select one',
						'daily': 'Daily',
						'bi-weekly': 'Bi-weekly',
						'weekly': 'Weekly',
						'bi-monthly': 'Bi-monthly',
						'monthly': 'Monthly',
						'quarterly': 'Quarterly',
						'seasonally': 'Seasonally',
						'semi-annually': 'Semi-annually',
						'annually': 'Annually'
					}
				},
				auction: {
					title: 'Auction',
					icon: 'auctions',
					formats: {
						'': 'Select one',
						'hybrid': 'Hybrid',
						'online': 'Online',
						'sealed': 'Sealed',
						'traditional': 'Traditional',
						'other': 'Other'
					},
					types: {
						'': 'Select one',
						'absolute': 'Absolute',
						'minimum': 'Minimum bid',
						'reserve': 'Reserve',
						'other': 'Other'
					}
				}
			},
			types: {
				agricultural: {
					'title': 'Agricultural',
					'icon': 'agricultural'
				},
				commercial: {
					'title': 'Commercial',
					'icon': 'commercial'
				},
				recreational: {
					'title': 'Recreational',
					'icon': 'recreational'
				},
				residential: {
					'title': 'Residential',
					'icon': 'residential'
				}
			},
			embeds: {
				sources: {
					'': 'Select one',
					'acres': 'Acres',
					'mapright': 'Land id',
					'matterport': 'Matterport'
				},
				examples: {
					'acres': '(eg https://www.acres.com/embed?savedId=ID)',
					'mapright': '(eg https://id.land/ranching/maps/ID/share/embed/)',
					'matterport': '(eg https://my.matterport.com/show/?m=ID)'
				}
			},
			taxes: {
				years: years
			},
			expenses: {
				types: {
					'': 'Select one',
					'association': 'Association',
					'initiation': 'Initiation',
					'service': 'Service',
					'usage': 'Usage'
				},
				periods: {
					'': 'Select one',
					'one-time': 'One-time',
					'daily': 'Daily',
					'bi-weekly': 'Bi-weekly',
					'weekly': 'Weekly',
					'bi-monthly': 'Bi-monthly',
					'monthly': 'Monthly',
					'quarterly': 'Quarterly',
					'seasonally': 'Seasonally',
					'semi-annually': 'Semi-annually',
					'annually': 'Annually'
				}
			},
			videos: {
				sources: {
					'': 'Select one',
					'youtube': 'YouTube',
					'vimeo': 'Vimeo'
				},
				examples: {
					'youtube': '(eg https://youtu.be/ID)',
					'vimeo': '(eg https://player.vimeo.com/video/ID)'
				}
			},
			accesses: {
				'': 'Select one',
				'public': 'Public road',
				'private': 'Private road',
				'easement': 'Easement',
				'none': 'None',
				'other': 'Other'
			},
			showing: {
				'': 'Select one',
				'appointment': 'Appointment only',
				'own': 'Go on your own',
				'approval': 'Contact for permission',
				'code': 'Contact for access code'
			},
			financing: {
				fees: {
					types: {
						'': 'Select one',
						'closing': 'Closing',
						'doc': 'Document',
						'record': 'Recording',
						'service': 'Service',
						'other': 'Other'
					},
					periods: {
						'': 'Select one',
						'one-time': 'One-time',
						'monthly': 'Monthly',
						'annually': 'Annually'
					}
				},
				expenses: {
					'': 'Select one',
					'buyer': 'Buyer pays',
					'seller': 'Seller pays',
					'split': 'Split payment'
				}
			},
			utilities: {
				options: $.context('utilities'),
				statuses: {
					'': 'Select one',
					'connected': 'Connected',
					'available': 'Available',
					'possible': 'Possible',
					'unavailable': 'Unavailable'
				}
			},
			schools: {
				levels: {
					'': 'Select one',
					'elementary': 'Elementary',
					'middle': 'Middle',
					'high': 'High'
				},
				types: {
					'': 'Select one',
					'public': 'Public',
					'private': 'Private',
					'charter': 'Charter',
					'magnet': 'Magnet'
				}
			},
			attributes: {
				lot: {
					views: [
						'City',
						'Desert',
						'Farm',
						'Harbor',
						'Lake',
						'Mountain',
						'Ocean',
						'Park',
						'River',
						'Scenic',
						'Water',
						'Woods'
					],
					features: [
						'Beach Rights',
						'Boat Slip',
						'Cleared',
						'Corner Lot',
						'Crops',
						'Cul-De-Sac',
						'Dock',
						'Dock Rights',
						'Garden',
						'Gate',
						'Lawn',
						'Level',
						'Partially Wooded',
						'Pond',
						'Sprinkler System',
						'Tennis Court',
						'Trails',
						'Wooded'
					]
				},
				exterior: {
					parking: [
						'Carport',
						'Driveway',
						'Garage',
						'Parking Lot',
						'Parking Pad',
						'RV Parking'
					],
					features: [
						'Arena',
						'Balcony',
						'Barbecue',
						'Barn',
						'Boat House',
						'Cabana',
						'Corral',
						'Deck',
						'Farm Equipment',
						'Grain Storage',
						'Greenhouse',
						'Guest House',
						'Kennel/Dog Run',
						'Livestock Equipment',
						'Outbuilding',
						'Patio',
						'Pool',
						'Pool House',
						'Porch',
						'Poultry Coop',
						'RV/Boat Storage',
						'Shed',
						'Stable',
						'Workshop'
					]
				},
				interior: {
					rooms: [
						'Bonus',
						'Den',
						'Dining',
						'Family',
						'Game',
						'Great',
						'Gym',
						'Kitchen',
						'Laundry',
						'Library',
						'Living',
						'Loft',
						'Media',
						'Office',
						'Utility'
					],
					appliances: [
						'Dishwasher',
						'Disposal',
						'Dryer',
						'Freezer',
						'Microwave',
						'Oven',
						'Refrigerator',
						'Washer'
					],
					floors: [
						'Bamboo',
						'Carpet',
						'Concrete',
						'Cork',
						'Granite',
						'Hardwood',
						'Laminate',
						'Linoleum',
						'Marble',
						'Softwood',
						'Stone',
						'Tile',
						'Vinyl'
					],
					features: [
						'Cable Available',
						'Central Vacuum',
						'Disabled Access',
						'Elevator',
						'Fireplace',
						'Furnished',
						'Home Theater',
						'In-Law Suite',
						'Indoor Pool',
						'Intercom',
						'Sauna',
						'Security System',
						'Skylight',
						'Spa',
						'Vaulted Ceiling',
						'Wet Bar',
						'Wired for Data'
					]
				},
				structure: {
					styles: [
						'A-Frame',
						'Barndominium',
						'Bungalow',
						'Cabin',
						'Cape Cod',
						'Colonial',
						'Contemporary',
						'Cottage',
						'Craftsman',
						'Dome',
						'Farmhouse',
						'Mansion',
						'Mediterranean',
						'Mid-Century Modern',
						'Modern',
						'Ranch',
						'Rustic',
						'Spanish',
						'Split Level',
						'Tudor',
						'Victorian'
					],
					materials: [
						'Aluminum Siding',
						'Asbestos',
						'Block',
						'Brick',
						'Cedar',
						'Cement',
						'Concrete',
						'Fiber Cement',
						'Glass',
						'Hardboard',
						'Log',
						'Masonry',
						'Metal',
						'Plywood',
						'Shake Siding',
						'Shingle Siding',
						'Stone',
						'Stucco',
						'Tile',
						'Vinyl Siding',
						'Wood Siding'
					],
					roof: [
						'Asphalt',
						'Composition',
						'Flat',
						'Membrane',
						'Metal',
						'Rubber',
						'Shake',
						'Slate',
						'Stone',
						'Tar',
						'Tile'
					],
					heating: [
						'Baseboard',
						'Coal',
						'Electric',
						'Fireplace',
						'Forced Air',
						'Geothermal',
						'Heat Pump',
						'Hot Water',
						'Kerosene',
						'Natural Gas',
						'Oil',
						'Propane',
						'Radiant',
						'Solar',
						'Space Heater',
						'Steam',
						'Wood'
					],
					cooling: [
						'Attic Fan',
						'Ceiling Fan',
						'Central Air',
						'Evaporative',
						'Geothermal',
						'Wall Unit',
						'Whole House Fan',
						'Window Unit'
					],
					features: [
						'Attic',
						'Double-Pane Windows',
						'Finished Basement',
						'Partially Finished Basement',
						'Unfinished Basement',
						'Warranty'
					]
				}
			}
		};
	},

	/**
	 * Protect from accidental navigation
	 */
	protect() {
		const scope = this;

		scope.protecting = setTimeout(() => {
			LS.confirm = conf => {
				conf.abort();

				LS.modal.confirm('Are you sure you want to leave? Unsaved changes will be lost.', () => {
					LS.confirm = null;

					$.history.go(conf.path);
				});
			}
		}, 10000);
	},

	/**
	 * Remove protection
	 */
	unprotect() {
		clearTimeout(this.protecting);

		delete LS.confirm;
	},

	/**
	 * Bind form submission
	 */
	initForm() {
		LS.form.restrict(this.$form, 'post');
	},

	/**
	 * Bind progress indicator
	 */
	initProgress() {
		const scope = this;

		$.events.on('.-is-available', 'click', (e, el) => {
			scope.setStep(
				$(el).index() + 1
			);
		}, {
			delegate: '$steps',
			namespace: 'post'
		});
	},

	/**
	 * Initialize navigation
	 */
	initNav() {
		const scope = this;

		$.events.on('$postNext, $postPrev', 'click', (e, el) => {
			const next = el === $$('postNext')[0];
			const step = $.app.post.$get('step') + (next ? 1 : -1);

			scope.setStep(step);
		}, {
			delegate: '$post',
			namespace: 'post'
		});
	},

	/**
	 * Initialize modals
	 */
	initModals() {
		$.events.on('$postModal', 'click', (e, el) => {
			LS.modal.open({
				model: {
					title: el.dataset.title,
					content: $.view.render('account-post.modals.' + el.dataset.view)
				},
				width: 520
			});
		}, {
			cancel: true,
			delegate: '$post',
			namespace: 'post'
		});
	},

	/**
	 * Initialize inputs
	 */
	initInputs() {
		const $post = $$('post');

		LS.util.restrict('[inputmode]', el => {
			$.app.post.$set('data.' + el.id, el.value);
		}, 'post', $post);

		$('textarea', $post).resize('post');

		$.events.on('input, select, textarea', 'change', (e, el) => {
			const id = el.id || el.dataset.id;

			if (id && id.search(/\.\d+/)) {
				const mode = el.inputMode;
				const numeric = mode === 'decimal' || mode === 'numeric';

				let value = el.value.trim();

				if (value && (numeric || el.nodeName === 'SELECT')) {
					if (numeric) {
						value = LS.util.parseNumber(value);
					}

					value = isNaN(value) ?
						value : Number(value);
				}

				$.app.post.$set('data.' + id, el.type === 'checkbox' ?
					el.checked : value
				);
			}
		}, {
			delegate: $post,
			namespace: 'post'
		});
	},

	/**
	 * Set initial format value form hash
	 */
	selectFormat() {
		const hash = $.routes.uri().hash;

		if (hash && $.app.post.$get('formats.' + hash)) {
			$.app.post.$set('data.format', hash);
		}
	},

	/**
	 * Navigate to specific step and initialize
	 *
	 * @param {Number} step
	 */
	setStep(step) {
		const scope = this;

		if (scope.currentStep) {
			if (! scope.validate()) {
				return;
			}

			$.app.post.$set('steps.' + scope.currentStep + '.available', true);
		}

		scope.currentStep = Object.keys($.app.post.$get('steps'))[step - 1];

		if (! scope.fired.includes(scope.currentStep)) {
			scope[scope.currentStep + 'Setup']();

			scope.fired.push(scope.currentStep);
		}

		if (scope[scope.currentStep + 'Init']) {
			scope[scope.currentStep + 'Init']();
		}

		$.app.post.$set('step', step);

		const $tab = $$('steps').children()
			.eq(step - 1);

		if ($tab.length) {
			$tab[0].scrollIntoView(false);
		}

		LS.util.top();
	},

	/**
	 * Drop empty rows
	 *
	 * @param {Array} sections
	 */
	drop(sections) {
		sections.forEach(section => {
			const rows = $.app.post.$get('data.' + section);

			let empty;
			let row;

			if (! rows || ! rows.length) {
				return;
			}

			let i = rows.length;

			while (i--) {
				row = rows[i];
				empty = true;

				Object.keys(row)
					.forEach(key => {
						if (empty && row[key]) {
							empty = false;
						}
					});

				if (empty) {
					$.app.post.$drop(`data.${section}.${i}`);
				}
			}
		});
	},

	/**
	 * Perform validation
	 *
	 * @returns {Boolean}
	 */
	validate() {
		const scope = this;

		return (scope[scope.currentStep + 'Validate'] || scope.validateStep).apply(scope);
	},

	/**
	 * Validate step
	 *
	 * @returns {Boolean}
	 */
	validateStep() {
		const scope = this;

		return LS.form.validate(scope.$form, null, null, {
			context: scope.$form.children()
				.filter((index, el) => ! el.hidden)
		});
	}
});